import ContactDomain from "./contact-domain";

export default class ContactListDomain {
  contacts: ContactDomain[];

  totalCount: string;

  constructor(contacts: ContactDomain[], totalCount: string) {
    this.contacts = contacts;
    this.totalCount = totalCount;
  }
}
